import {Component} from '@angular/core';

@Component({
    selector: 'app-vision',
    templateUrl: './vision.component.html',
    styleUrl: './vision.component.css'
})
export class VisionComponent {

}
